import { Reducer } from 'interfaces'
import { CropperState } from 'interfaces/cropper'
import { CROP_IMAGE, CLEAR_CROPPER, CROP_IMAGE_RESULT } from 'actions/cropperActions'

const INITIAL_STATE = {
  inputFile: null,
  outputFile: null,
}
export const cropper: Reducer<CropperState> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case CROP_IMAGE: {
      const { image } = action.payload
      return {
        inputFile: image,
        outputFile: null,
      }
    }

    case CROP_IMAGE_RESULT: {
      const { image } = action.payload
      return {
        inputFile: null,
        outputFile: image,
      }
    }

    case CLEAR_CROPPER: {
      return INITIAL_STATE
    }
  }
  return prevState
}

